module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_confirmation-367c4dcb39a400e3d1923f18a8c6ccf5.jpg";